import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClearCacheService {
  async clearCacheForFile(filename: string): Promise<any> {
    const cache = await caches.open('dcss-mobile-prod-dhs');
    try {
      const keys = await cache.keys();
      for (const key of keys) {
        if (key.url.includes(filename)) {
          await cache.delete(key);
        }
      }
    } catch (error) {
    }
  }
}

export function clearIndexHtmlCache(cacheService: ClearCacheService) {
  return () => {
    cacheService.clearCacheForFile('index.html');
  };
}
